<template lang="pug">
modal(:name="modalName" :adaptive="$attrs.adaptive || false" v-on="$listeners"
  v-bind="$attrs" :width="$attrs.width || '85%'"
   height="auto" :clickToClose="clickToClose").regular-modal
  .regular-modal-inner
    .regular-modal-inner--header
      slot(name="close")
        close-modal-icon(@click.native="hideModal" v-if="closable")
      slot(name="header")
      slot(name="title")
        template(v-if="title")
          h1.regular-modal--title {{title}}
    .regular-modal-inner--body
      slot
    .regular-modal-inner--footer(v-if="$slots.footer")
      slot(name="footer" v-bind:close="hideModal")
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";
import VModal from 'vue-js-modal';
import CloseModalIcon from "@/backoffice/components/modals/CloseModalIcon.vue";
Vue.use(VModal);

@Component({
  name: "RegularModal",
  components: {CloseModalIcon}
})
export default class RegularModal extends Vue {
  @Prop({required: false, default: null})
  clickToClose!: boolean;

  @Prop({required: false, default: null})
  forcedName: string | null;

  @Prop({required: false, default: true})
  closable: boolean

  @Prop({required: false, default: null})
  title: string | null


  uuid = this.generateUUID();

  get modalName() {
    return this.forcedName || 'regular-modal-' + this.uuid;
  }

  generateUUID() {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
      d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  showModal() {
    this.$modal.show(this.modalName);
  }
}
</script>

<style scoped lang="less">
.regular-modal {

  .regular-modal-inner {
    //display: grid;
    //grid-template-rows: auto 1fr auto;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  ::v-deep {
    .vm--modal {
      max-height: 95%;
      display: flex;
      flex-direction: column;
    }
  }
  //::v-deep {
  //  .vm--modal {
  //    //border: 1px solid #cccccc;
  //
  //    height: auto;
  //    max-height: 90%;
  //    //border-radius: 4px;
  //    //padding: 5px;
  //    overflow-y: auto;
  //    width: 100%;
  //
  //    &::-webkit-scrollbar {
  //      width: 11px;
  //    }
  //
  //    &::-webkit-scrollbar-track {
  //      //box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  //      background: #cccccc;
  //    }
  //
  //    &::-webkit-scrollbar-thumb {
  //      background: #80bd1c;
  //      //outline: 1px solid slategrey;
  //    }
  //  }
  //}

  .regular-modal-inner {
    margin: 20px 20px 20px 20px;
    min-height: 50px;
    .regular-modal--title {
      margin: 0 0 10px 0;
      font-weight: normal;
    }
    .regular-modal-inner--header {
      //display: flex;
      //flex-direction: row;
      //justify-content: space-between;
      //align-items: center;
      margin-bottom: 15px;
      flex: none;
      border-bottom: 1px solid #eee;
      flex-shrink: 0;
    }

    .regular-modal-inner--body {
      padding-right: 10px;
      // box-sizing: border-box;
      //display: flex;
      //flex-direction: column;
      //justify-content: space-between;
      //align-items: center;
      //margin-bottom: 20px;

      //border: 1px solid #cccccc;
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis:auto;

      height: auto;
      //border-radius: 4px;
      //padding: 5px;
      overflow-y: auto;
      width: 100%;

      &::-webkit-scrollbar {
        width: 11px;
      }

      &::-webkit-scrollbar-track {
        //box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background: #cccccc;
      }

      &::-webkit-scrollbar-thumb {
        background: #80bd1c;
        //outline: 1px solid slategrey;
      }
    }

    .regular-modal-inner--footer {
      //display: flex;
      //flex-direction: row;
      //justify-content: flex-end;
      //align-items: center;
      //margin-bottom: 20px;
      flex:none;
      border-top: 1px solid #eee;
      margin-top: 15px;
      padding-top: 15px;
      flex-shrink: 0;
      // margin-bottom: 15px;
    }
  }


  ::v-deep {
    .close-modal-icon {
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
}
</style>
